import { Entidad } from "../../../../data/Entidad";
import { MGrupo } from "../../../../data/model/MGrupo";
import { UIUtilViewGrupos } from "../../../utilView/Grupos";
import { IGridExtraColumns } from "../entidad/GridExtraColumns";

export class MGrupoGrid extends MGrupo implements IGridExtraColumns {
    TagNivel: string | number;
    TagGrado: string | number;
    TagGrupo: string | number;
    TagAlumno: string | number;
    Alumnos: Map<number, Entidad.IAlumno>;

    constructor(grupoModel: MGrupo) {
        super(grupoModel);

        this.Alumnos = this.GetAlumnosEnGrupo();
        this.TagAlumno = Array.from(this.Alumnos.values())
            .filter(d => d.IdChildMovimiento == Entidad.CNinioMovimiento.Activo).length;

        this.TagGrupo = UIUtilViewGrupos._GetLblGrupoName(this, false);
    }

    public getAlumnosActivos(): number {
        return Array.from(this.Alumnos.values())
            .filter(d => (d.IdChildMovimiento == Entidad.CNinioMovimiento.Activo))
            .length;
    }
}